import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { type IResponse, encryptedRequest } from "../core/api.client";

interface ITwfInsertApiRequest {
  id?: string;
  mobileNo: string;
  journeyName: string; // icors or default
  journeyType?: string;
  prodName: string;
  custType: string;
  appId?: string;
  actualLoanAmt?: string;
  tenureInMon?: string;
  roi?: string;
  emiAmt?: string;
  offerId?: string;
  offerAmt?: string;
  appDtls?: [
    {
      custId: string;
    },
  ];
}

interface ITwfInsertApiResponse {
  id: string;
  eventCode: string;
  journeyName: string;
}

export async function postTWFInsertApi(
  requestBody: ITwfInsertApiRequest
): Promise<IResponse<ITwfInsertApiResponse>> {
  try {
    const response = await encryptedRequest<ITwfInsertApiResponse, ITwfInsertApiRequest>({
      method: "POST",
      url: API_PATHS.twfInsert,
      data: requestBody,
    });

    if (response.statusCode !== 90) {
      throw new Error(response.message);
    }

    return response;
  } catch (error) {
    logErrorToNewRelic(error as string, {
      errorType: "Error in TWF insert",
    });
    throw error;
  }
}
